// extracted by mini-css-extract-plugin
export var borderRadius = "_bq-4";
export var large = "_bq-3";
export var logoContainer = "_bq-0";
export var nameLogo = "_bq-2";
export var small = "_bq-1";